import styled from "styled-components";

export const VerlaufKomplett = styled.table`
    margin-left: 5em;
    padding: 1em;
    display: block;
    height: 15em;
    width: fit-content;
    overflow: scroll;
`

export const VerlaufButton = styled.button`
    width: 100%;
    border-radius: 5px;
    border: 1px solid lightslategrey;
    padding: 0.2em 0.5em;

    &.active {
        background-color: rgba(32, 178, 171, 0.5); 

        &:hover {
            text-decoration: none;
            background-color: rgba(236, 12, 49, 0.2);
            color: rgba(236, 12, 49);
            border: 1px solid rgba(236, 12, 49);
        }
    }

`